const campaigns: { [key: string]: string } = {
    Tasks: "MyTasks-Usability",
    Browse: "Browse-Usability",
    Search: "Browse-Usability",
    Document: "DocumentViewer-Usability",
    TA_Campaign: "TA-Campaign"
};

export default campaigns;
